import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute , RouterModule } from '@angular/router';
import { EmailService } from './../../../../../../_services/email/email.service';
import { Location } from '@angular/common';
import { UserService } from './../../../../../../_services/user.service';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, MapfreButtonComponent],
  selector: 'app-policy-account-exists',
  templateUrl: './policy-account-exists.component.html',
})
export class PolicyAccountExistsComponent implements OnInit {
  emailMask: string;
  constructor(
    private router: Router,
    private routeParams: ActivatedRoute,
    private userService: UserService,
    private emailService: EmailService,
    private location: Location
  ) {}

  getUserData() {
    this.userService.$user.subscribe((user) => {
      if (user) {
        this.emailMask = this.emailService.maskEmail(user.b2cEmail);
      }
    });
  }
  goBack() {
    this.location.back();
  }
  ngOnInit(): void {
    this.getUserData();
  }
}
